import { useState } from "react";
import { injectIntl } from "react-intl";
import TypeaheadBox from "../Form/TypeaheadBox";
import intlShape from "../../shapes/intlShape";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";
import { userShape } from "../../shapes";
import { withUser } from "../../wrappers";

type TenantTypeaheadProps = {
  api: apiShape;
  intl: intlShape;
  name: string;
  user: userShape;
  notifier: notifierShape;
  assetId?: number;
  values?: {
    manufacturer?: $TSFixMe;
  };
};

export function TenantTypeahead(props: TenantTypeaheadProps) {
  const [tenants, setTenants] = useState();
  const [fetching, setFetching] = useState();

  const { api, notifier, intl, values, name, user, assetId } = props;
  const loadOptions = async (searchText = "") => {
    try {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
      setFetching(true);

      const endpoint = assetId
        ? `/assets/${assetId}/tenant-options`
        : "/tenants";

      const response = await api.get(endpoint, {
        admin_user_id: user.id,
        name: `${searchText}*`,
      });
      setTenants(
        response.tenants.map((tenant: $TSFixMe) => ({
          id: tenant.id,
          name: tenant.name,
        })),
      );
    } catch (error) {
      notifier.showError(api.translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const selectedTenant = values[name];

  return user ? (
    <TypeaheadBox
      {...props}
      // @ts-expect-error TS(2322) FIXME: Type '{ info: string | null; options: undefined; f... Remove this comment to see the full error message
      info={
        selectedTenant?.new
          ? intl.formatMessage({ id: "tenant_typeahead.new_info" })
          : null
      }
      options={tenants}
      fetching={fetching}
      loadOptions={loadOptions}
    />
  ) : null;
}

export default injectIntl(withUser(withNotifier(withApi(TenantTypeahead))));
